<template>
  <v-card elevation="0" class="pa-2">
    <v-card-title v-if="courseGroupId">
      <h3><strong>Editar turma</strong></h3>
    </v-card-title>
    <v-card-title v-else>
      <h3><strong>Cadastrar turma</strong></h3>
    </v-card-title>
    <v-container
        style="max-width: unset"
        class="pa-1 pt-1 ma-0"
    >
      <v-form ref="courseForm" v-model="courseForm" lazy-validation>
        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Curso</label>
            <v-select
                color="black"
                v-model="courseGroup.courseId"
                clearable
                :items="courses"
                outlined
                append-icon="mdi-chevron-down"
                required
                placeholder="Selecione o curso"
                dense
                hide-details
                item-text="name"
                item-value="id"
                :rules="[rules.required]"
            ></v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Local onde o curso será realizado</label>
            <v-textarea
                color="black"
                v-model="courseGroup.local"
                :items="courses"
                outlined
                required
                placeholder="Digite o local onde o curso será realizado"
                dense
                rows="2"
                hide-details
                :rules="[rules.required]"
            ></v-textarea>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Dias das aulas</label>
            <v-select
                color="black"
                v-model="daysOfTheWeekSelected"
                clearable
                attach
                :items="daysOfTheWeek"
                outlined
                append-icon="mdi-chevron-down"
                required
                placeholder="Dias das aulas"
                dense
                item-text="name"
                item-value="value"
                :rules="[rules.required]"
                multiple
                hide-details
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    color="#bc0000"
                    class="my-1"
                >
                  <span style="color: #FFFFFF; font-size: 14px">{{ item.name }}</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <label>Horário de início</label>
            <v-text-field
                outlined
                placeholder="Horário de início do curso"
                v-model="courseGroup.startTime"
                attach
                dense
                clearable
                :rules="[rules.required]"
                color="#000000"
                type="time"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <label>Hora de término</label>
            <v-text-field
                outlined
                placeholder="Hora de término do curso"
                v-model="courseGroup.endTime"
                attach
                dense
                clearable
                :rules="[rules.required]"
                color="#000000"
                type="time"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <label>Data de início</label>
            <v-text-field
                outlined
                placeholder="Data de início do curso"
                v-model="courseGroup.startDate"
                attach
                dense
                clearable
                :rules="[rules.required]"
                color="#000000"
                type="date"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <label>Data de término</label>
            <v-text-field
                outlined
                placeholder="Data de término do curso"
                v-model="courseGroup.endDate"
                attach
                dense
                clearable
                :rules="[rules.required]"
                color="#000000"
                type="date"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <label>Data de início das inscrições</label>
            <v-text-field
                outlined
                placeholder="Data de início das inscrições do curso"
                v-model="courseGroup.startDateInscription"
                attach
                dense
                clearable
                :rules="[rules.required]"
                color="#000000"
                type="date"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <label>Data de término das inscrições</label>
            <v-text-field
                outlined
                placeholder="Data de término das inscrições do curso"
                v-model="courseGroup.endDateInscription"
                attach
                dense
                clearable
                :rules="[rules.required]"
                color="#000000"
                type="date"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="6" lg="3" xl="3">
            <label>Quantidade de vagas</label>
            <v-text-field
                outlined
                placeholder="Quantidade de vagas do curso"
                v-model="courseGroup.numberOfVacancies"
                attach
                dense
                clearable
                :rules="[rules.required]"
                color="#000000"
                type="number"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6" lg="3" xl="3">
            <label>Ativo?</label>
            <v-select
                color="black"
                v-model="courseGroup.active"
                clearable
                :items="active"
                outlined
                append-icon="mdi-chevron-down"
                required
                placeholder="Ativo?"
                dense
                item-text="name"
                item-value="value"
                :rules="[rules.required]"
            ></v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6" lg="3" xl="3">
            <label>Período</label>
            <v-select
                color="black"
                v-model="courseGroup.period"
                clearable
                :items="periods"
                outlined
                append-icon="mdi-chevron-down"
                placeholder="Período do curso"
                dense
                item-text="name"
                item-value="value"
                :rules="[rules.required]"
            ></v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6" lg="3" xl="3">
            <label>Nível</label>
            <v-select
                color="black"
                v-model="courseGroup.level"
                clearable
                :items="levels"
                outlined
                append-icon="mdi-chevron-down"
                required
                placeholder="Nível do curso"
                dense
                item-text="name"
                item-value="value"
                :rules="[rules.required]"
            ></v-select>
          </v-col>
        </v-row>

        <v-row class="d-flex justify-center pt-0 ma-0 pa-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
            <v-btn
                elevation="0"
                class="secondary-button"
                width="100%"
                @click="close()"
            >
              <span>Voltar</span>
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
            <v-btn
                elevation="0"
                class="primary-button"
                width="100%"
                @click="submit()"
            >
              <span v-if="courseGroupId">Editar turma</span>
              <span v-else>Cadastrar turma</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Utils from "@/Utils/FormatDate";

export default {
  name: "CourseGroup",
  components: {},
  computed: {},

  props: {
    courseId: {type: Number, required: false, default: null},
    courseGroupId: {type: Number, required: false, default: null},
  },

  created() {
  },

  async mounted() {
    this.courseGroup = {
      courseId: null,
      startTime: null,
      endTime: null,
      startDate: null,
      endDate: null,
      daysOfTheWeek: null,
      period: null,
      level: null,
      numberOfVacancies: 0,
      startDateInscription: null,
      endDateInscription: null,
      active: null,
      local: null,
    }
    if (this.courseGroupId) {
      await this.getCourseGroup()
    }
    await this.getCourses()
  },
  data() {
    return {
      outlined: true,
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 11,
        precision: 2,
        max: 10
      },
      courseGroup: {
        courseId: null,
        startTime: null,
        endTime: null,
        startDate: null,
        endDate: null,
        daysOfTheWeek: null,
        period: null,
        level: null,
        numberOfVacancies: 0,
        startDateInscription: null,
        endDateInscription: null,
        active: null,
        local: null,
      },
      daysOfTheWeekSelected: [],
      active: [
        {name: "Não", value: 'false'},
        {name: "Sim", value: true},
      ],
      filter: {
        pageSize: 10,
        currentPage: 0,
        page: 1,
        totalPages: 1,
        totalItems: 1,
      },
      periods: [
        {name: "Matutino", value: "0"},
        {name: "Vespertino", value: '1'},
        {name: "Noturno", value: '2'}
      ],
      levels: [
        {name: "Iniciante", value: "0"},
        {name: "Intermediário", value: '1'},
        {name: "Avançado", value: '2'}
      ],
      daysOfTheWeek: [
        {name: "Domingo", value: 0},
        {name: "Segunda-feira", value: 1},
        {name: "Terça-feira", value: 2},
        {name: "Quarta-feira", value: 3},
        {name: "Quinta-feira", value: 4},
        {name: "Sexta-feira", value: 5},
        {name: "Sábado", value: 6}
      ],
      courseForm: false,
      apiService: new ApiService(),
      courses: [],
      rules: {
        required: (value) => !!value || "Campo requerido.",
      }
    };
  },

  methods: {
    formatNowFormat(date) {
      return Utils.nowFormat(date);
    },

    async getCourses() {
      try {
        const {content} = await this.apiService.get(`course`)
        this.courses = content

      } catch (e) {

      }
    },

    async getCourseGroup() {
      try {
        const {content} = await this.apiService.get(`courseGroup/${this.courseGroupId}`,)
        this.courseGroup = content
        this.courseGroup.startDate = this.formatNowFormat(this.courseGroup.startDate)
        this.courseGroup.endDate = this.formatNowFormat(this.courseGroup.endDate)
        this.courseGroup.startDateInscription = this.formatNowFormat(this.courseGroup.startDateInscription)
        this.courseGroup.endDateInscription = this.formatNowFormat(this.courseGroup.endDateInscription)
        this.courseGroup.period = this.courseGroup.period.toString()
        this.courseGroup.level = this.courseGroup.level.toString()
        this.daysOfTheWeekSelected = JSON.parse(this.courseGroup.daysOfTheWeek)
      } catch (e) {

      }
    },

    async close() {
      this.$emit('reload')
      this.$emit('close')
    },

    async submit() {
      try {
        const body = this.courseGroup
        if (!this.$refs.courseForm.validate()) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Preencha os campos corretamente",
            trace: null,
          });
          return
        }

        if (!this.daysOfTheWeekSelected || this.daysOfTheWeekSelected.length <= 0) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Selecione os dias do curso!",
            trace: null,
          });
          return
        }
        body.daysOfTheWeek = JSON.stringify(this.daysOfTheWeekSelected)

        let message = ''
        let statusCode = null
        if(this.courseGroupId){
          const response = await this.apiService.put(`courseGroup/${this.courseGroupId}`, body, false)
          message = response.message
          statusCode = response.statusCode
        } else {
          const response = await this.apiService.post("courseGroup", body, false)
          message = response.message
          statusCode = response.statusCode
        }
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "success",
          title: message,
          message: message,
          trace: null,
        });
        if (statusCode == 200) {
          this.$refs.courseForm.reset()          // limpa todos os campos
          this.$refs.courseForm.resetValidation()
          this.courseId = null
          await this.close()
        }

      } catch (e) {

      }
    },
  },

  watch: {},
};
</script>

<style lang='scss' scoped>
#chartRecipeAndOrder {
  width: 100%;
}

#chartPaymentMethod {
  width: 100%;
}

.card-red {
  background: linear-gradient(to bottom, #f54784, #d62828);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

.card-black {
  background: linear-gradient(to bottom, #000000, #666666);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  padding: 10px 15px;
  text-align: left;
}

tr {
  cursor: pointer;
}

th {
  font-weight: bold;
  border-bottom: 2px solid #ddd;
}

/* coluna receita */
td.receita {
  background: linear-gradient(to right, #f8d7da, #f5c6cb);
  text-align: left;
  font-weight: bold;
  color: #333;
}

/* coluna metros */
td.metros {
  background: linear-gradient(to right, #f8d7da, #f1b0b7);
  text-align: left;
  font-weight: bold;
  color: #333;
}

tr:nth-child(even) td {
  background-color: #fafafa;
}
.remove-button {
  border: 1px solid #bc0000;
  border-radius: 4px;
}

.remove-button:hover {
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  color: white !important;
}
</style>
